// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__1d-sF","image":"NotFound_image__MmyM3","text":"NotFound_text__2WVe5"};